import * as types from './types';
import * as actionTypes from './constants';
import { IAction } from '@state/types';

const defaultState: types.IFoldersState = { };

const designTypeReducer = (
  state: types.IFoldersState = defaultState, 
  action: IAction | types.ISetFolderAction
) => {
  switch ((action as IAction).type) {
    case actionTypes.SET_FOLDERS: {
      return {...state, folders : (action as types.ISetFoldersAction).folders};
    }
    case actionTypes.SET_FOLDER: {
      return {...state, folder : (action as types.ISetFolderAction).folder};
    }
    default: {
      return state;
    }
  }
};


export default designTypeReducer;
